import axios from 'axios';

export default {
  methods: {
    getData() {
      axios.get(process.env.VUE_APP_LARAVEL_ENDPOINT + "/api/user/info")
        .then((response) => {
          this.name = response.data.user.name;
          this.surname = response.data.user.surname;
          this.email = response.data.user.email;
        })
        .catch((error) => {
          if (error.response) {
this.errors.push(error.response.data.message);}
else {
this.errors.push(error)}
        })
    },
    getAgrements() {
      axios.get(process.env.VUE_APP_LARAVEL_ENDPOINT + "/api/user/agrements")
        .then((response) => {
          this.newsletter_agr = response.data.agrements.newsletter;
          this.sms_agr = response.data.agrements.sms;
          this.phone_agr = response.data.agrements.phone;
        })
        .catch((error) => {
          if (error.response) {
this.errors.push(error.response.data.message);}
else {
this.errors.push(error)}
        })
    },
    getLevel() {
      axios.get(process.env.VUE_APP_LARAVEL_ENDPOINT + "/api/user/level")
        .then((response) => {
          this.level = response.data.level;
        })
        .catch((error) => {
          if (error.response) {
this.errors.push(error.response.data.message);}
else {
this.errors.push(error)}
        })
    }
  }
}